import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getApplication} from './getApplication';

export const applicationQueryOptions = (id: string | null) =>
  queryOptions({
    queryKey: keys.applications.detail(id ?? ''),
    queryFn: () => getApplication(id ?? ''),
    enabled: id !== null && id !== '',
  });
